document.addEventListener('DOMContentLoaded', () => {
  const solutions = document.querySelectorAll('[data-solution]');

  solutions.forEach((solution) => {
    const atcForm = solution.querySelector('[data-solution-atc]');
    if (!atcForm) return;

    atcForm.addEventListener('submit', (event) => {
      event.preventDefault();
      const submitButton = atcForm.querySelector('button[type="submit"]');
      window.lhLandingsAddToCart(atcForm, submitButton);
    });
  });
});
